module.exports = __webpack_public_path__ + "img/creditcards-we-accept.2c122397.png";